/**
 * <s-type-hint data-hints="a, b, c">: types the hints into the wrapped input's placeholder one by one
 * (type, hold, erase, next), like the live Athora search drawer. Runs only while the closest <dialog> is
 * open (or always when there is none) and the field is empty. Reduced motion: shows the first hint, still.
 */
class STypeHint extends HTMLElement {
  #input = null;
  #hints = [];
  #timer = 0;
  #i = 0;
  #pos = 0;
  #erasing = false;
  #original = '';

  connectedCallback() {
    this.#input = this.querySelector('input');
    this.#hints = (this.dataset.hints || '').split(',').map((s) => s.trim()).filter(Boolean);
    if (!this.#input || this.#hints.length === 0) return;
    this.#original = this.#input.placeholder;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.#input.placeholder = this.#hints[0];
      return;
    }
    this.#tick();
  }

  disconnectedCallback() {
    clearTimeout(this.#timer);
  }

  #active() {
    const dialog = this.closest('dialog');
    return (!dialog || dialog.open) && this.#input.value === '';
  }

  #tick = () => {
    if (!this.isConnected) return;
    if (!this.#active()) {
      this.#timer = setTimeout(this.#tick, 400);
      return;
    }
    const word = this.#hints[this.#i];
    let delay = 70;
    if (!this.#erasing) {
      this.#pos += 1;
      if (this.#pos >= word.length) {
        this.#pos = word.length;
        this.#erasing = true;
        delay = 1600;
      }
    } else {
      this.#pos -= 1;
      delay = 35;
      if (this.#pos <= 0) {
        this.#pos = 0;
        this.#erasing = false;
        this.#i = (this.#i + 1) % this.#hints.length;
        delay = 350;
      }
    }
    this.#input.placeholder = word.slice(0, this.#pos) || this.#original;
    this.#timer = setTimeout(this.#tick, delay);
  };
}

if (!customElements.get('s-type-hint')) customElements.define('s-type-hint', STypeHint);
